import styles from "./index.module.scss";

import { Header } from "../../../components/layout/header";
import { useLanguage } from "../../../hooks/useLanguage";

import french from '../../../assets/illustrations/hero/desktop-fr.svg';
import english from '../../../assets/illustrations/hero/desktop-en.svg';

export const Desktop = () => {
    const { language } = useLanguage();
    
    return (
        <div className={styles.home}>
            <Header />
            <img src={language === 'fr' ? french : english} alt="Hero" className={styles.hero} />
        </div>
    );
}